/** The enum NfcIso. */
export enum NfcIso {
  ISO_14443A
}
